import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

import { Lumber } from '@paragon/contract-library';
import { applyLumberPatch, LumberSelects } from '@paragon/material-lists';

type OwnProps = {
  name: string;
  lumbers: Lumber[];
  lumber: Lumber;
  updateMethod: (lumber: Lumber) => void;
  disabled?: boolean;

  inputSx?: SxProps<Theme>;
  lumberSelectSx?: SxProps<Theme>;
};

export default (props: OwnProps) => (
  <>
    <Typography sx={{ ml: 1 }}>{`${props.name}:`}</Typography>

    <Box sx={props.lumberSelectSx}>
      <LumberSelects
        inputSx={props.inputSx}
        strict
        lumbers={props.lumbers}
        value={props.lumber}
        onChange={(patch) => props.updateMethod(applyLumberPatch(props.lumber, patch, props.lumbers))}
        disabled={props.disabled}
      />
    </Box>
  </>
);
